// extracted by mini-css-extract-plugin
module.exports = {"recommends":"business-recommendation_recommends__26iEF","thumb":"business-recommendation_thumb__2_dGj"};